import logo from '@assets/logo/quickobjects.svg';

export function Header() {
  return (
    <header>
      <div className="flex justify-center items-center p-4 border-b-2 border-gray-100 ">
        <img src={logo} alt="logo" />
      </div>
    </header>
  );
};
